import * as React from 'react';

import cn from 'classnames';
import tinytime from 'tinytime';
import { Message as AIMessage } from '@ai-sdk/react';

import { ExternalLinkSVG, InterviewSVG } from '@components/svgs';

import { ToolInvocation } from '../../types';

const dateTemplate = tinytime('{Mo}/{DD}/{YYYY} {h}:{mm}{a}');

interface CreatedStudyProps {
  message: AIMessage;
  className?: string;
}

export const CreatedStudy: React.FC<CreatedStudyProps> = ({ message, className }) => {
  const studyToolInvocation = (message.toolInvocations as ToolInvocation[])?.find(
    (invocation) =>
      invocation.toolName?.startsWith('greatquestion_') &&
      invocation.state === 'result' &&
      invocation.result &&
      typeof invocation.result === 'object' &&
      'study_id' in invocation.result
  );

  const studyId =
    studyToolInvocation?.result &&
    typeof studyToolInvocation.result === 'object' &&
    'study_id' in studyToolInvocation.result
      ? (studyToolInvocation.result as any).study_id
      : null;

  if (!studyId) {
    return null;
  }

  return (
    <a href={`/studies/${studyId}`} className={cn(className, 'p-0')} target='_blank' rel='noreferrer'>
      <div className='flex w-full rounded-lg border border-blue-200 bg-blue-50 p-3 text-left transition-colors hover:bg-blue-100'>
        <div className='flex w-full items-center space-x-2'>
          <div className='flex items-center justify-center rounded-full bg-indigo-100 p-2'>
            <InterviewSVG className='h-4 w-4 text-indigo-600' />
          </div>
          <div className='flex min-w-0 flex-1 flex-col'>
            <div className='text-sm font-medium text-blue-900'>Study {studyId}</div>
            <div className='text-xs text-blue-600'>
              Created on {dateTemplate.render(new Date(message.createdAt || Date.now()))}
            </div>
          </div>
          <div className='flex items-center justify-center'>
            <ExternalLinkSVG className='h-4 w-4 text-blue-600' />
          </div>
        </div>
      </div>
    </a>
  );
};
